import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/functions';

var firebaseConfig = {
    apiKey: "AIzaSyAk8nC1d1ePN-Q5zFZBe06pImFcMrc8uN8",
    authDomain: "ondago-29d43.firebaseapp.com",
    databaseURL: "https://ondago-29d43.firebaseio.com",
    projectId: "ondago-29d43",
    storageBucket: "ondago-29d43.appspot.com",
    messagingSenderId: "862984649825",
    appId: "1:862984649825:web:f88de4c4f9a09d76027e20",
    measurementId: "G-RVJ1W41MKS"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const auth = firebase.auth();
const firestore = firebase.firestore();
const functions = firebase.functions();

export {
    auth,
    firestore,
    functions
}